import React from "react";
import search from "../../assets/images/Search.svg";
import fligths from "../../assets/images/Flights.svg";
import aircraft from "../../assets/images/Aircraft.svg";
import airport from "../../assets/images/Airport.svg";
import total from "../../assets/images/Total.svg";
import imports from "../../assets/images/Import.svg";
import AddFlightModal from "../Modal/AddFlightModal";
import AddAircraftModal from "../Modal/AddAircraftModal";
import AddFlightManual from "../Modal/AddFlightManual";
import { Link, useNavigate } from "react-router-dom";
import "./Sidebar.scss";
import dashboard from "../../assets/images/Dashboard.svg";
import chevron from "../../assets/images/chevron.svg";
import Slide from "@mui/material/Slide";
import {
  getActiveTab,
  getSidebarStatus,
  setSidebarShow,
} from "../../store/slices/layout-slice";
import { useAppDispatch, useAppSelector } from "../../hooks/app";

function LogBookLinks() {
  const navigate=useNavigate()
  const [showNestedList, setShowNestedList] = React.useState(false);
  const [aircraftNestedList, setAircraftNestedList] = React.useState(false);
  const [addFlight, setAddFlight] = React.useState(false);
  const [addAircraft, setAddAircraft] = React.useState(false);

  const [isAutoModalOpen, setIsAutoModalOpen] = React.useState(false);
  const [isManualModalOpen, setIsManualModalOpen] = React.useState(false);

  const handleOpenAuto = () => {
    setIsAutoModalOpen(true);
    setIsManualModalOpen(false);
  };

  const handleOpenManual = () => {
    setIsAutoModalOpen(false);
    setIsManualModalOpen(true);
  };

  const handleCloseAuto = () => {
    setIsAutoModalOpen(false);
  };

  const handleCloseManual = () => {
    setIsManualModalOpen(false);
  };

  const handleAddFlight = () => {
    setAddFlight(true);
    setIsAutoModalOpen(true);
  };

  const handleCloseFlight = () => {
    setAddFlight(false);
  };

  const handleAddAircraft = () => {
    setAddAircraft(true);
  };

  const handleCloseAircraft = () => {
    setAddAircraft(false);
  };

  const handleToggleAircraftList = () => {
    setAircraftNestedList(!aircraftNestedList);
  };

  const handleToggleNestedList = () => {
    setShowNestedList(!showNestedList);
  };


  const activeTab = useAppSelector(getActiveTab);
  const sidebarStatus = useAppSelector(getSidebarStatus);
  const dispatch = useAppDispatch();

  return (
    <>
      {/* <li style={{ display: "flex", gap: "10px" }}>
        <img src={search} alt="Search Logo" />
        <a>Search</a>
      </li> */}
       <li onClick={()=>navigate("/")} style={{ display: "flex", gap: "10px" }}>
            <img src={dashboard} alt="Dashboard Logo" />
            <span>Dashboard</span>
      </li>
      <li
        onClick={handleToggleNestedList}
        style={{ display: "flex", gap: "10px" }}
      >
        <img src={fligths} alt="Flights Logo" />
        <span>Flights</span>
      </li>
      {showNestedList && (
        <ul className="main_menu">
          <li onClick={()=>navigate("/logbook/flights")}>
            <span>All Flights</span>
          </li>
          <li onClick={handleOpenAuto}>
            <span>Add New Flight</span>
          </li>

          {isAutoModalOpen && (
            <AddFlightModal
              open={isAutoModalOpen}
              onCloseFm={handleCloseAuto}
              onOpenManual={handleOpenManual}
            />
          )}

          {isManualModalOpen && (
            <AddFlightManual
              open={isManualModalOpen}
              onCloseFm={handleCloseManual}
              onOpenAuto={handleOpenAuto}
            />
          )}
        </ul>
      )}
      <li
        onClick={handleToggleAircraftList}
        style={{ display: "flex", gap: "10px" }}
      >
        <img src={aircraft} alt="Aircraft Logo" />
        <span>Aircraft</span>
      </li>
      {aircraftNestedList && (
        <ul className="main_menu">
          <li onClick={()=>navigate("/logbook/aircrafts")}>
            <span>All Aircrafts</span>
          </li>
          {/* <li>
                <Link to="/logbook/aircrafts/aircraft_models">
                  Aircraft Models
                </Link>
              </li> */}
          <li onClick={handleAddAircraft}>
            <span>Add New Aircraft</span>
          </li>

          {/* Add New AirCraft Form  */}
          <AddAircraftModal open={addAircraft} onClose={handleCloseAircraft} />
          {/* Form ends here */}

          {/* <li>
                <a>Flying Club</a>
              </li>
              <li>
                <a>Import Aircraft</a>
              </li> */}
        </ul>
      )}
      {/* <li style={{ display: "flex", gap: "10px" }}>
        <img src={airport} alt="Airport Logo" />
        <Link to="/logbook/airports">Airports</Link>
      </li> */}
      <li style={{ display: "flex", gap: "10px" }}>
        <img src={total} alt="Backup Logo" />
        <Link to="/logbook/backup">Backup</Link>
      </li>
      <li onClick={()=>navigate("/logbook/import")} style={{ display: "flex", gap: "10px" }}>
        <img src={imports} alt="Imports Logo" />
        <span>Import</span>
      </li>
    </>
  );
}

export default LogBookLinks;
